import { Config } from './types'

const plusMinusConfig: { [key: string]: Config } = {
  '1': {
    minNumerator: 2,
    maxNumerator: 8,
    minDenominator: 4,
    maxDenominator: 10,
    maxVariation: 2,
  },
  '2': {
    minNumerator: 2,
    maxNumerator: 18,
    minDenominator: 10,
    maxDenominator: 20,
    maxVariation: 5,
  },
  '3': {
    minNumerator: 2,
    maxNumerator: 48,
    minDenominator: 6,
    maxDenominator: 50,
    maxVariation: 10,
  },
  '4': {
    minNumerator: 2,
    maxNumerator: 98,
    minDenominator: 30,
    maxDenominator: 98,
    maxVariation: 20,
  },
}
/**
 *
 * @param difficultyLevel
 * @returns configuration object based on difficulty level
 */
export function getRangesByDifficulty(difficultyLevel: number): Config {
  return plusMinusConfig[difficultyLevel] || plusMinusConfig[1]
}
